import { useEffect, useRef } from 'react'
import useDebounce from './useDebounce'

export default function useInputDebounce( value: any, delay: number, callback: ( arg: any ) => void ) {
	const debounceValue = useDebounce( value, delay )
	const isInitialMount = useRef( true )

	useEffect(
		() => {
			// we don't want to fire off the callback function on mount, only on update
			if ( isInitialMount.current ) {
				isInitialMount.current = false
			} else {
				callback( debounceValue )
			}
		},
		[ debounceValue ]
	)

	return debounceValue
}
